import { html, createSignal, createEffect, currentRoute, navigate } from 'onefold';
import { navSections } from '../config/navigation';
import { OnefoldLogo } from '../components/SvgIcon';

export function Sidebar(): Node {
  const expandedSections = createSignal<Set<string>>(new Set(['Get Started']));

  // Auto-expand section based on current route
  createEffect(() => {
    const route = currentRoute();
    for (const section of navSections) {
      for (const link of section.links) {
        if (link.path === route) {
          expandedSections.set(prev => {
            const next = new Set(prev);
            next.add(section.title);
            return next;
          });
          return;
        }
      }
    }
  });

  const toggleSection = (title: string) => {
    expandedSections.set(prev => {
      const next = new Set(prev);
      if (next.has(title)) next.delete(title);
      else next.add(title);
      return next;
    });
  };

  const handleNav = (path: string) => {
    navigate(path);
    // Close mobile sidebar
    document.getElementById('sidebar')?.classList.remove('open');
    document.getElementById('overlay')?.classList.remove('open');
  };

  return html`
    <aside id="sidebar" class="sidebar">
      <div class="sidebar-logo">
        ${OnefoldLogo()}
        <span class="wordmark">one<span>fold</span></span>
        <span class="version">v0.1.6</span>
      </div>
      <nav class="sidebar-nav">
        ${() => navSections.map(section => html`
          <div class=${() => 'sidebar-section' + (expandedSections().has(section.title) ? '' : ' collapsed')}>
            <div class="sidebar-section-title" onclick=${() => toggleSection(section.title)}>
              ${section.title}
              <span class="arrow">▼</span>
            </div>
            <ul class="sidebar-links">
              ${section.links.map(link => html`
                <li>
                  <a class=${() => 'sidebar-link' + (currentRoute() === link.path ? ' active' : '')}
                     onclick=${() => handleNav(link.path)}>
                    ${link.label}
                  </a>
                </li>
              `)}
            </ul>
          </div>
        `)}
      </nav>
    </aside>
  `;
}
